/**
 * Форматирует серийный номер в маску: xx xxxx xx xx xx xxx xxxxxxxx (2-4-2-2-2-3-8)
 * Всего 23 цифры.
 */
export const formatSN = (value?: string | null): string => {
  if (!value) return '-'
  const digits = value.replace(/\D/g, '').slice(0, 23)

  return [
    digits.slice(0, 2), // xx
    digits.slice(2, 6), // xxxx
    digits.slice(6, 8), // xx
    digits.slice(8, 10), // xx
    digits.slice(10, 12), // xx
    digits.slice(12, 15), // xxx
    digits.slice(15, 23), // xxxxxxxx
  ]
    .filter(Boolean)
    .join(' ')
}
